import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSiteContent } from "../../context/SiteContentContext";
import { SiteLink } from "../site/siteText";
import "./navbar.css";
import AccountingLogo from "../../assests/images/maneenopkao-acc.png";
import NewsLogo from "../../assests/images/maneenopkao-news.png";

// Brand block shared by header and footer
export function OfficialBrand({ name, tagline, className = "" }) {
  return (
    <Link to="/" className={`brand official-brand ${className}`.trim()}>
      <span className="brand-wordmark">
        <strong>{name}</strong>
        <small>{tagline}</small>
      </span>
      <span className="brand-logos" aria-hidden="true">
        <img className="brand-accounting-logo" src={AccountingLogo} alt="" />
        <img className="brand-news-logo" src={NewsLogo} alt="" />
      </span>
    </Link>
  );
}

function Navbar() {
  const { siteContent } = useSiteContent();
  const header = siteContent.siteHeader || {};
  const menu = Array.isArray(header.menu) ? header.menu : [];
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // close the mobile menu after any navigation — key also changes when the link points to the current page
  useEffect(() => { setOpen(false); }, [location.key]);

  // HashRouter would read "#main" as a route, so move focus to the content ourselves
  const skipToContent = (e) => {
    e.preventDefault();
    const main = document.getElementById("main");
    if (!main) return;
    if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1");
    main.focus();
    main.scrollIntoView({ block: "start" });
  };

  return (
    <>
      <a className="skip" href="#main" onClick={skipToContent}>ข้ามไปเนื้อหา</a>
      <header className="header">
        <div className="container nav-wrap">
          <OfficialBrand name={header.brandName} tagline={header.brandTagline} />

          <button
            type="button"
            className="menu-toggle"
            aria-label="เปิดเมนู"
            aria-controls="navigation"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
          </button>

          <nav id="navigation" className={open ? "open" : ""}>
            {menu.map((item, i) => (
              <SiteLink key={`${item.to}-${i}`} to={item.to}>
                {item.label}
              </SiteLink>
            ))}
            <SiteLink className="nav-cta" to={header.ctaTo || "/newspaper/submit"}>
              {header.ctaLabel}{" "}
              <span aria-hidden="true">↗</span>
            </SiteLink>
          </nav>
        </div>
      </header>
    </>
  );
}

export default Navbar;
